import * as faqCatergoriesEffects from './faq-category.effect';
import * as faqEffects from './faq.effect';

export const effects = { ...faqCatergoriesEffects, ...faqEffects };
